import { arrayWithoutSubset, setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  LeadershipTopConversationThemesLoadAction,
  LeadershipTopConversationThemesLoadFulfilledAction,
} from '../../domains/leadershipTopConversationThemes/actions.types';

import { ViewerLeadershipTopConversationThemes } from './types';

export const initialState: ViewerLeadershipTopConversationThemes = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const loadTopConversationThemesFulfilled = (
  state: ViewerLeadershipTopConversationThemes,
  action: LeadershipTopConversationThemesLoadFulfilledAction
) => {
  if (!state.fulfilled) {
    return setFulfilled(action.payload.entities.viewerLeadershipTopConversationThemes);
  }

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      ...action.payload.entities.viewerLeadershipTopConversationThemes,
      viewerLeadershipTopConversationThemeIds: arrayWithoutSubset(
        action.payload.entities.viewerLeadershipTopConversationThemes.viewerLeadershipTopConversationThemeIds,
        state.fulfilled.viewerLeadershipTopConversationThemeIds
      ),
    },
  };
};

const reducer: Reducer<ViewerLeadershipTopConversationThemes, LeadershipTopConversationThemesLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'LEADERSHIP_TOP_CONVERSATION_THEMES.LOAD_PENDING':
      return setPending();
    case 'LEADERSHIP_TOP_CONVERSATION_THEMES.LOAD_FULFILLED':
      return loadTopConversationThemesFulfilled(state, action);
    case 'LEADERSHIP_TOP_CONVERSATION_THEMES.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
